// SMART DEMO — Mira Style asset manifest (FINAL EXPORT)
// Kontrollü static asset paketi için TEK KAYNAK path tanımı.
//
// Bu dosya yalnızca PATH tanımlar; binary (image/video) üretmez, indirmez.
// Kullanıcı projeyi download ettikten sonra binary dosyaları public/ altındaki
// exact klasörlere koyar ve local build alır. HİÇBİR .ts/.tsx dosyasına dokunmaz.
//
// Final asset seti (15 binary):
//   1 logo + 4 womens-fashion + 4 bags-accessories + 4 jewelry + 2 video
//
// Dış URL / hotlink / stock / Stable Diffusion external URL YOK.
// Readdy Files / Supabase Storage YOK — tüm media kullanıcının kendi serverından.
// Sahte gerçek firma YOK — "Mira Style" tamamen kurgu demo markadır.

export const MIRA_STYLE_ASSET_ROOT = "/demo-presets/onlinesales/mira-style";

export interface MiraStyleManifest {
  logo: string;
  womensFashion: string[];
  bagsAccessories: string[];
  jewelry: string[];
  videos: string[];
}

export const MIRA_STYLE_MANIFEST: MiraStyleManifest = {
  logo: `${MIRA_STYLE_ASSET_ROOT}/logo/logo.webp`,
  womensFashion: [
    `${MIRA_STYLE_ASSET_ROOT}/womens-fashion/01.webp`,
    `${MIRA_STYLE_ASSET_ROOT}/womens-fashion/02.webp`,
    `${MIRA_STYLE_ASSET_ROOT}/womens-fashion/03.webp`,
    `${MIRA_STYLE_ASSET_ROOT}/womens-fashion/04.webp`,
  ],
  bagsAccessories: [
    `${MIRA_STYLE_ASSET_ROOT}/bags-accessories/01.webp`,
    `${MIRA_STYLE_ASSET_ROOT}/bags-accessories/02.webp`,
    `${MIRA_STYLE_ASSET_ROOT}/bags-accessories/03.webp`,
    `${MIRA_STYLE_ASSET_ROOT}/bags-accessories/04.webp`,
  ],
  jewelry: [
    `${MIRA_STYLE_ASSET_ROOT}/jewelry/01.webp`,
    `${MIRA_STYLE_ASSET_ROOT}/jewelry/02.webp`,
    `${MIRA_STYLE_ASSET_ROOT}/jewelry/03.webp`,
    `${MIRA_STYLE_ASSET_ROOT}/jewelry/04.webp`,
  ],
  videos: [
    `${MIRA_STYLE_ASSET_ROOT}/videos/01.mp4`,
    `${MIRA_STYLE_ASSET_ROOT}/videos/02.mp4`,
  ],
};